// check empty object function
export const checkEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}